import { z } from "zod";

const currentYear = new Date().getFullYear();

const plateOldPattern = /^[A-Z]{3}[0-9]{4}$/;
const plateMercosulPattern = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
const renavamPattern = /^\d{9,11}$/;

/** Valida formato apenas quando o valor está preenchido. */
const optionalString = () => z.string().optional().or(z.literal(""));

export const vehicleFormSchema = z.object({
	// Obrigatórios (model: string sem ?)
	plate: z
		.string()
		.min(1, "Placa é obrigatória")
		.transform((value) => value.toUpperCase().replace(/[^A-Z0-9]/g, ""))
		.refine(
			(value) =>
				plateOldPattern.test(value) || plateMercosulPattern.test(value),
			{ message: "Placa inválida" }
		),
	brand: optionalString(),
	model: optionalString(),
	description: optionalString(),

	// Opcionais (model: string? / int? / enum?)
	chassisNumber: optionalString().refine(
		(val) => !val || val.length === 0 || val.length === 17,
		{ message: "O número do chassi deve conter exatamente 17 caracteres" }
	),
	renavam: optionalString().refine(
		(val) => !val || val.length === 0 || renavamPattern.test(val),
		{ message: "O Renavam deve conter entre 9 e 11 dígitos" }
	),
	bodyType: optionalString(),
	color: optionalString().refine((val) => !val || val.length <= 30, {
		message: "A cor não pode exceder 30 caracteres",
	}),
	transmissionType: optionalString(),
	engineType: optionalString(),
	modelYear: optionalString().refine(
		(val) => {
			if (!val || val.length === 0) {
				return true;
			}
			const year = Number.parseInt(val, 10);
			return Number.isFinite(year) && year >= 1900 && year <= currentYear + 1;
		},
		{
			message: "O ano do modelo deve estar entre 1900 e o próximo ano.",
		}
	),
	manufactureYear: optionalString().refine(
		(val) => {
			if (!val || val.length === 0) {
				return true;
			}
			const year = Number.parseInt(val, 10);
			return Number.isFinite(year) && year >= 1900 && year <= currentYear + 1;
		},
		{
			message: "O ano de fabricação deve estar entre 1900 e o próximo ano.",
		}
	),
	odometer: optionalString().refine(
		(val) => {
			if (!val || val.length === 0) {
				return true;
			}
			const num = Number.parseInt(val, 10);
			return Number.isFinite(num) && num >= 0;
		},
		{ message: "Hodômetro deve ser maior ou igual a 0" }
	),
	fuelType: z.string().optional(),
	group_id: z.number().nullable().optional(),
});

export type VehicleFormSchema = z.infer<typeof vehicleFormSchema>;
